import * as ValidateModel from '../../shared/ValidateModel';
import GraphicTag from './graphicTag';

class GraphicTags {
    readonly items: GraphicTag[];

    constructor(items: GraphicTag[]) {
        ValidateModel.isArray(items, 'items');
        ValidateModel.isArrayOfInstances(items, GraphicTag, 'GraphicTag');
        this.items = items;
    }

    getItems = (): GraphicTag[] => this.items;

    getLabelValueList = (): {
        label: string;
        value: string;
    }[] =>
        this.getItems().map((item) => ({
            label: item.getName(),
            value: item.getId().toString(),
        }));

    getItemById = (id: number): GraphicTag | null => {
        ValidateModel.isNumber(id, 'id');
        const found = this.items.find((item) => item.getId() === id);
        if (found === undefined) {
            return null;
        }
        return found;
    };
}

export default GraphicTags;
